import { createFeatureSelector } from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import { NexiaBasketState } from './reducer/nexia-basket.reducer';


export const selectNexiaBasketFeature  = createFeatureSelector<NexiaBasketState>(StoreKeys.NEXIA_BASKET);
